import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { type Task, task } from 'ember-concurrency';
import type CustomTagDefinition from 'lumen/models/custom-tag-definition';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';

export interface CustomTagsRouteModel {
  definitions: Task<CustomTagDefinition[], []>;
}

export default class MarketSettingsPropertyTagsCustomRoute extends Route {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare store: Services['store'];

  requestDefinitionsTask = task({ restartable: true }, async () => {
    const marketId = this.hotelAndMarketService.market.id;
    return await this.store.query<CustomTagDefinition>(
      'custom-tag-definition',
      {
        market_id: marketId,
      },
    );
  });

  model(): CustomTagsRouteModel {
    const model: CustomTagsRouteModel = {
      definitions: this.requestDefinitionsTask,
    };

    void model.definitions.perform();

    return model;
  }

  @action
  refreshModel(): void {
    this.refresh();
  }
}
